import { getNamespace } from '../../utils/storage';
import * as api from './ClinicApi';
import * as type from './ClinicType';

export const getClinics =
    (service = api.getClinics) =>
    async (dispatch) => {
        const namespace = getNamespace();
        dispatch({
            type: type.GET_CLINICS.REQUEST
        });
        return await service(namespace)?.then((response) => {
            dispatch({
                type: type.GET_CLINICS.SUCCESS,
                payload: response.data
            });
        });
    };
export const createClinic =
    (body, service = api.createClinic) =>
    async (dispatch) => {
        return await service(body)?.then((response) => {
            dispatch({
                type: type.CREATE_CLINIC,
                payload: response.data
            });
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'New clinic successfully created.',
                    status: 200
                }
            });
            return response;
        });
    };
export const updateClinic =
    (clinicId, body, service = api.updateClinic) =>
    async (dispatch) => {
        return await service(clinicId, body)?.then((response) => {
            dispatch({
                type: type.UPDATE_CLINIC,
                payload: response.data
            });
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'Clinic information successfully edited',
                    status: 200
                }
            });
            return response;
        });
    };
